import { mdiFileDownload, mdiPrinterOutline } from '@mdi/js';
import { MAIN_IMAGE_ROOT } from 'app_config';
import type { CustomFormReportDocument } from 'common/models';
import {
  Button,
  Icon,
  PageContainer,
  PageContent,
  PageContentWrapper,
  PageSubheader,
  PdfViewer
} from 'components';
import LanguageContainer from 'components/LanguageContainer/LanguageContainer';
import { PageActionsV2 } from 'components/Layout';
import { useCustomTranslation } from 'helpers/translationHelper';
import fileDownload from 'js-file-download';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

interface Props {
  document: CustomFormReportDocument;
  lang?: string;
}

type RouteParams =
  | 'tenantCode'
  | 'customerId'
  | 'customFormId'
  | 'reportId'
  | 'serviceObjectId'
  | 'interventionId'
  | 'orderId';

const PublicReportPdf: React.FC<Props> = (props): React.ReactElement => {
  const { document, lang } = props;

  const params = useParams<RouteParams>();

  const { t } = useCustomTranslation();

  const [pdfDocument, setPdfDocument] = useState<Blob>();

  const title = document.serviceObjectName ? (
    <div>
      <div className="title">{document.serviceObjectName}</div>
      <div className="subtitle">{document.name}</div>
    </div>
  ) : (
    <div className="title">{document.name}</div>
  );

  const helmetTitle = params.serviceObjectId
    ? `${document.serviceObjectName} - ${document.name}`
    : document.name;

  return (
    <LanguageContainer lang={lang}>
      <PageContainer
        // isLoading={interventionQuery.isLoading}
        // error={interventionQuery.error}
        pageTitle={helmetTitle || ''}
        className="PublicReportPage"
      >
        <PageSubheader
          title={title}
          hideBackButton
          actions={
            <PageActionsV2
              actions={
                pdfDocument && (
                  <>
                    <Button
                      type="primary"
                      onClick={() => fileDownload(pdfDocument, `${helmetTitle}.pdf`)}
                      icon={<Icon path={mdiFileDownload} />}
                    >
                      {t('common.download')}
                    </Button>
                    <Button
                      onClick={() => window.open(URL.createObjectURL(pdfDocument))}
                      icon={<Icon path={mdiPrinterOutline} />}
                    >
                      {t('common.print')}
                    </Button>
                  </>
                )
              }
            />
          }
        />
        <PageContentWrapper>
          <PageContent topLevel className="PdfReportPage_content">
            <PdfViewer
              file={`${MAIN_IMAGE_ROOT}${document.publicUrl}`}
              getDocument={setPdfDocument}
            />
          </PageContent>
        </PageContentWrapper>
      </PageContainer>
    </LanguageContainer>
  );
};

export default PublicReportPdf;
